export enum RouteKeys {
  List = '/banner',
  New = '/banner/new',
  Edit = '/banner/:id',
}
